// extracted by mini-css-extract-plugin
export default {"pageFrame":"AccountInfoStep_pageFrame__XwyAJ","title":"AccountInfoStep_title__DE+e-","inputFrame":"AccountInfoStep_inputFrame__4Z-1Z","submit":"AccountInfoStep_submit__6OQUl"};